export enum Hierarchy {
   Primary = 'PRIMARY',
   Secondary = 'SECONDARY',
   Tertiary = 'TERTIARY',
   Link = 'LINK'
}

export enum SubVariant {
   Primary = 'PRIMARY',
   Destructive = 'DESTRUCTIVE',
   DestructiveOutline = 'DESTRUCTIVE_OUTLINE',
   Gray = 'GRAY',
   GrayOutline = 'GRAY_OUTLINE',
   Success = 'SUCCESS',
   Violet = 'VIOLET'
}
